/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NumeroUtileDto } from '../../models/numero-utile-dto';

export interface ApiNumeroUtileNumeroUtileListGet$Params {}

export function apiNumeroUtileNumeroUtileListGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiNumeroUtileNumeroUtileListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<NumeroUtileDto>>> {
    const rb = new RequestBuilder(rootUrl, apiNumeroUtileNumeroUtileListGet.PATH, 'get');
    if (params) {
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<NumeroUtileDto>>;
        }),
    );
}

apiNumeroUtileNumeroUtileListGet.PATH = '/api/numero-utile/numero-utile-list';
